export var BACKOFFICE_ROLES = {
    ADMIN: "ADMIN",
    ATC: "ATC",
    HUNTER: "HUNTER",
    READ_ONLY: "READONLY",
    ONLY_COLLECTIVES_READ: "ONLYCOLLECTIVESREAD",
};
var normalizeRole = function (role) { return role.toLowerCase(); };
var hasAnyRole = function (userRoles, requiredRoles) {
    var normalizedUserRoles = userRoles.map(normalizeRole);
    return requiredRoles.some(function (role) {
        return normalizedUserRoles.includes(normalizeRole(role));
    });
};
export var hasRoleOrPermission = function (userRoles, userPermissions, requiredRoles, requiredPermissions) {
    if (requiredRoles === void 0) { requiredRoles = []; }
    if (requiredPermissions === void 0) { requiredPermissions = []; }
    // Verifica si el usuario tiene al menos un rol requerido
    var hasRequiredRole = hasAnyRole(userRoles, requiredRoles);
    // Verifica si el usuario tiene al menos un permiso requerido
    var hasRequiredPermission = requiredPermissions.some(function (permission) { return userPermissions.includes(permission); });
    // Devuelve true si cumple con alguno de los requisitos
    return hasRequiredRole || hasRequiredPermission;
};
export var isBackofficeReadOnly = function (userRoles) {
    return hasAnyRole(userRoles, [BACKOFFICE_ROLES.READ_ONLY]);
};
export var canViewSignoUsers = function (userRoles, userPermissions) {
    if (userPermissions === void 0) { userPermissions = []; }
    return hasRoleOrPermission(userRoles, userPermissions, [
        BACKOFFICE_ROLES.ADMIN,
        BACKOFFICE_ROLES.ATC,
        BACKOFFICE_ROLES.HUNTER,
        BACKOFFICE_ROLES.READ_ONLY,
    ]);
};
export var canManageSignoUsers = function (userRoles, userPermissions) {
    if (userPermissions === void 0) { userPermissions = []; }
    return hasRoleOrPermission(userRoles, userPermissions, [
        BACKOFFICE_ROLES.ADMIN,
        BACKOFFICE_ROLES.ATC,
    ]);
};
export var canChangeUserCollective = function (userRoles, userPermissions) {
    if (userPermissions === void 0) { userPermissions = []; }
    return hasRoleOrPermission(userRoles, userPermissions, [
        BACKOFFICE_ROLES.ADMIN,
        BACKOFFICE_ROLES.ATC,
        BACKOFFICE_ROLES.HUNTER,
    ]);
};
export var canViewCollectives = function (userRoles, userPermissions) {
    if (userPermissions === void 0) { userPermissions = []; }
    return hasRoleOrPermission(userRoles, userPermissions, [
        BACKOFFICE_ROLES.ADMIN,
        BACKOFFICE_ROLES.ATC,
        BACKOFFICE_ROLES.HUNTER,
        BACKOFFICE_ROLES.READ_ONLY,
        BACKOFFICE_ROLES.ONLY_COLLECTIVES_READ,
    ]);
};
export var canManageCollectives = function (userRoles, userPermissions) {
    if (userPermissions === void 0) { userPermissions = []; }
    return hasRoleOrPermission(userRoles, userPermissions, [
        BACKOFFICE_ROLES.ADMIN,
        BACKOFFICE_ROLES.ATC,
    ]);
};
export var canManageCollectiveLeads = function (userRoles, userPermissions) {
    if (userPermissions === void 0) { userPermissions = []; }
    return hasRoleOrPermission(userRoles, userPermissions, [
        BACKOFFICE_ROLES.ADMIN,
        BACKOFFICE_ROLES.ATC,
        BACKOFFICE_ROLES.HUNTER,
    ]);
};
